import * as React from 'react';
import { Col } from 'react-bootstrap';
import { FieldArray } from 'redux-form';

import { FormFieldArrayStatus } from '@acceligentllc/shared/enums/formFieldArrayStatus';

import { WORK_ORDER_FORM } from 'af-constants/reduxForms';

import type { OwnProps as AddressesProps } from 'af-components/SharedForms/WorkLocationAddress';
import Addresses from 'af-components/SharedForms/WorkLocationAddress';

import type { AddressArrayFM } from '../formModel';
import Section from '../Shared/Section';

interface OwnProps {
	disabled: boolean;
	addresses: AddressArrayFM[];
	resetTimer: () => void;
	change: (fieldName: string, value: FormFieldArrayStatus) => void;
	selector: (fieldName: string) => AddressArrayFM;
	jobTimezone: Nullable<string>;
	companyTimezone: Nullable<string>;
}

type Props = OwnProps;

const WorkOrderWorkLocation: React.FC<Props> = (props) => {
	const { addresses, disabled, change, selector, jobTimezone, companyTimezone } = props;

	const {
		latitude,
		longitude,
	} = React.useMemo(() => {
		for (const _address of (addresses ?? [])) {
			if (_address.status !== FormFieldArrayStatus.REMOVED) {
				return {
					latitude: _address?.address?.backup?.latitude ?? null,
					longitude: _address?.address?.backup?.longitude ?? null,
				};
			}
		}
		return {
			latitude: null,
			longitude: null,
		};

	}, [addresses]);

	return (
		<Section
			label="Work Locations"
			tooltip={`
				Location where work is being done. Very important when deciding which time zone will be used for payroll report.
				If time zone can be decided from first address, that one is used. If not, job's time zone is used.
			`}
		>
			<Col sm={24}>
				<FieldArray<AddressesProps>
					canBeEmpty={true}
					change={change}
					companyTimezone={companyTimezone}
					component={Addresses}
					disabled={disabled}
					disableMap={disabled}
					formName={WORK_ORDER_FORM}
					jobTimezone={jobTimezone}
					latitude={latitude}
					longitude={longitude}
					name="addresses"
					removeOnDelete={false}
					selector={selector}
				/>
			</Col>
		</Section>
	);
};

export default React.memo(WorkOrderWorkLocation);
